module.exports = __webpack_public_path__ + "img/MonstersGuidetoAnger-Cover-1280.b2ecdd80.png";